var $ = jQuery;

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

$(window).scroll(function(event) {
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('header').removeClass('nav-up').addClass('nav-down');
        }
    }

    lastScrollTop = st;
}

// Scroll to anchor

$("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 800, function() {

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
        });
    } // End if
});

$(window).ready(function() {

// Add loading Animation on button click
    $('#load-more').click(function() {
        $(' <i class="fas fa-spinner fa-spin"></i>').appendTo(this);
    })


// Show Seminar Box if no dates are avaiable
    $('ul#topics li').click(function() {
        const topic = $(this).attr('id');
        $('.seminar_links').hide().removeClass('show_this');
        $('.' + topic).addClass('show_this');
    })

    $('.module-layotterbulletboxinteractive').each(function () {
        const module = $(this);
        const hideClass = 'd-none';

        module.find('.js-presence-online-switch').click(function (e) {
            if ($(e.target).is(':checked')) {
                module.find('.content--presence').addClass(hideClass);
                module.find('.content--online').removeClass(hideClass);
            } else {
                module.find('.content--presence').removeClass(hideClass);
                module.find('.content--online').addClass(hideClass);
            }
        });
    });
})

$.initialize(".no_dates_message", function() {
    $('.show_this').show();
});
